import GiveAllTrailsBanner from './GiveAllTrailsBanner';

export default GiveAllTrailsBanner;
